import React from 'react'
import Helmet from 'react-helmet'
import '../../assets/scss/init.scss'
import favicon from './favicon.png'

class Layout extends React.Component {
  render() {
    const { children } = this.props

    return (
      <div className="layout">
        <Helmet
          defaultTitle="DY's 개발공부 로그"
          link={[
            {
              rel: 'icon',
              type: 'image/png',
              sizes: '32x32',
              href: `${favicon}`,
            },
          ]}
        />
        {children}
      </div>
    )
  }
}

export default Layout
